import fetch from 'isomorphic-fetch';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { getHeaders } from '~/genericFunctions';
import { loanTypes } from '~/constants/loanTypes';
import { responseReceived } from '~/lib/mobile-x';

export const submitLoansApplication = async ({ globalData, requestData: { customerDetails, formData, keyDetailsData, loanOfferData } }) => {
  const { host, protocol } = window.location;
  let data, requestBody;

  const loanAmountIndex = get(formData, 'loanAmountIndex');
  const loanOption = get(loanOfferData, `loanOptions[${loanAmountIndex}]`) || {};
  const getExistingLoan = (type) => {
    if (type === loanTypes.topup) {
      return {
        existingLoan: get(loanOfferData, 'existingLoan'),
      };
    }
    return;
  };

  requestBody = {
    'customerDetails': {
      ...customerDetails,
    },
    'loanOffer': {
      id: get(globalData, 'offerId'),
      type: get(loanOfferData, 'type'),
      productName: get(loanOfferData, 'productName'),
      preApprovedCreditLimit: get(loanOfferData, 'preApprovedCreditLimit'),
      ...getExistingLoan(get(globalData, 'type'), loanOfferData),
    },
    'loanDetails': {
      leapOfferCodes: get(loanOfferData, 'leapOfferCodes'),
      depositAccount: get(loanOfferData, 'depositAccount'),
      preApprovedAccountNumber: get(loanOfferData, 'preApprovedAccountNumber'),
      ...loanOption,
    },
  };

  try {
    data = await submit({
      body: isEmpty(keyDetailsData)? requestBody: { keyDetails: keyDetailsData, ...requestBody },
      globalData,
      url: `${protocol}//${host}/api/loan-application`,
    });
  } catch (err) {
    throw Error ('Error in API submitLoansApplication');
  }
  return data;
};

const submit = async ({ body, globalData, url }) => {

  let cis = (get(globalData, 'offerId') === 'Nva_TopUp' || get(globalData, 'offerId') === 'Nva_TopUp_CP' || get(globalData, 'offerId') === 'TopUp_AN_MB' || get(globalData, 'offerId') === 'TopUp_CP_MB')? '000000060712191' : '37334';
  let response, data;
  try {
    response = await fetch(url, {
      method: 'post',
      body: JSON.stringify(body),
      headers: getHeaders({
        globalData,
        cis,
      }),
    });
    responseReceived(get(response, 'status'));
  } catch (err) {
    throw Error('Error in response');
  }

  if (!response.ok) {
    throw Error(response.statusText);
  }
  data = await response.json();
  return data;
};
